import React from 'react'

export default props => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 8.01245C1.25 5.94138 2.92893 4.26245 5 4.26245H19C21.0711 4.26245 22.75 5.94138 22.75 8.01245V18.9999C22.75 21.071 21.0711 22.7499 19 22.7499H5C2.92893 22.7499 1.25 21.071 1.25 18.9999V8.01245ZM5 5.76245C3.75736 5.76245 2.75 6.76981 2.75 8.01245V18.9999C2.75 20.2426 3.75736 21.2499 5 21.2499H19C20.2426 21.2499 21.25 20.2426 21.25 18.9999V8.01245C21.25 6.76981 20.2426 5.76245 19 5.76245H5Z"
      fill="#14142B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 1.25002C7.41421 1.24988 7.75011 1.58555 7.75026 1.99976L7.75128 5.01251C7.75143 5.42672 7.41575 5.76262 7.00154 5.76276C6.58733 5.7629 6.25143 5.42723 6.25128 5.01302L6.25026 2.00027C6.25011 1.58606 6.58579 1.25016 7 1.25002Z"
      fill="#14142B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 1.25C17.4142 1.25 17.75 1.58579 17.75 2V4.63158C17.75 5.04579 17.4142 5.38158 17 5.38158C16.5858 5.38158 16.25 5.04579 16.25 4.63158V2C16.25 1.58579 16.5858 1.25 17 1.25Z"
      fill="#14142B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 9.36844C5.25 8.95423 5.58579 8.61844 6 8.61844L18 8.61844C18.4142 8.61844 18.75 8.95423 18.75 9.36844C18.75 9.78265 18.4142 10.1184 18 10.1184L6 10.1184C5.58579 10.1184 5.25 9.78265 5.25 9.36844Z"
      fill="#14142B"
    />
  </svg>
)
